import { BrowserRouter, Routes, Route, Link, useLocation } from 'react-router-dom'
import { useLayoutEffect } from 'react'

type Prop = {
    children? : JSX.Element[] | JSX.Element
}
const ScrollToTop = ({children}:Prop) => {
  const location = useLocation();
  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);
  return <>
    {children}
  </>
} 

export default ScrollToTop